/** Traductions page stock / lots (FR / AR) */
export const stockPageFr = {
  viewDetails: 'Voir détails',
  editProduct: 'Modifier produit',
  manageLots: 'Gérer lots',
  deleteProduct: 'Supprimer produit',
  moreActions: 'Plus d\'actions',
  productCol: 'Produit',
  imageCol: 'Image',
  categoryCol: 'Catégorie',
  subcategoryCol: 'Sous-catégorie',
  typeCol: 'Type',
  locationCol: 'Emplacement',
  stockCol: 'Stock',
  inCol: 'Entrée',
  outCol: 'Sortie',
  lotsCol: 'Lots',
  valueCol: 'Valeur',
  actionsCol: 'Actions',
  lowStock: 'Stock faible',
  noLots: 'Aucun lot',
  basedOnPurchases: 'Basé sur achats',
  lotsActive: 'actif(s)',
  loading: 'Chargement...',
  loadError: 'Erreur lors du chargement des données',
  noStockData: 'Aucune donnée de stock',
  addProductsHint: 'Commencez par ajouter de nouveaux produits',
  migrationNeededHint:
    'Des achats existent sans lots — le stock reste vide. Lancez la migration des lots.',
  migrationBtn: 'Migrer les lots',
  selectedCount: 'sélectionné(s)',
  deleteSelected: 'Supprimer sélection',
  editProductTitle: 'Modifier Produit',
  stockHistoryTitle: 'Historique du Stock',
  lotsTitle: 'Gestion des Lots',
  tabLots: 'Lots',
  tabHistory: 'Historique mouvements',
  tabInventur: 'Inventaire',
  ledgerHistory: {
    title: 'Mouvements de stock',
    standaloneTitle: 'Historique des mouvements (tous produits)',
    openBtn: 'Historique des mouvements',
    refresh: 'Actualiser',
    loading: 'Chargement…',
    showing: '{{shown}} / {{total}} mouvements',
    empty: 'Aucun mouvement pour ce filtre',
    noBusiness: 'Entreprise non sélectionnée',
    filterProduct: 'Produit (ID)',
    filterProductPh: 'ID produit…',
    filterType: 'Type',
    filterAllTypes: 'Tous les types',
    filterLocation: 'Emplacement',
    filterStore: 'Magasin',
    filterStorePh: 'ex. principal…',
    filterLimit: 'Limite',
    colSeq: 'N°',
    colType: 'Type',
    colQty: 'Qté',
    colProduct: 'Produit',
    colLot: 'Lot',
    colLocation: 'Lieu',
    colStore: 'Magasin',
    colActor: 'Opérateur',
    colWhen: 'Date',
    colNote: 'Note',
    type_PURCHASE: 'Achat',
    type_SALE: 'Vente',
    type_SALE_RETURN: 'Retour vente',
    type_VOID: 'Annulation',
    type_TRANSFER_OUT: 'Transfert sortant',
    type_TRANSFER_IN: 'Transfert entrant',
    type_EXPIRY: 'Péremption',
    type_ADJUSTMENT: 'Ajustement',
    type_CONSUMPTION: 'Consommation',
    type_PRODUCTION_CONSUME: 'Prod. consommation',
    type_PRODUCTION_OUTPUT: 'Prod. sortie'
  },
  inventur: {
    title: 'Inventaire physique',
    hint: 'Saisissez le stock physique (unité de base). Les écarts sont enregistrés comme ajustements de stock.',
    colLot: 'Lot',
    colSystem: 'Système',
    colCounted: 'Compté',
    colDelta: 'Écart',
    changes: '{{count}} écart(s) à comptabiliser',
    review: 'Vérifier les écarts',
    reviewTitle: 'Approbation de l’inventaire',
    reviewHint: 'Contrôlez les écarts, puis approuvez pour mettre à jour le stock.',
    approve: 'Approuver et comptabiliser',
    saveDraft: 'Enregistrer brouillon',
    draftSaved: 'Brouillon d’inventaire enregistré (en attente d’approbation)',
    backToCount: 'Retour au comptage',
    commit: 'Valider l’inventaire',
    saving: 'Enregistrement…',
    success: '{{count}} ajustement(s) enregistré(s)',
    noop: 'Aucun écart — rien à enregistrer',
    failed: 'Échec de l’inventaire',
    noBusiness: 'Entreprise non sélectionnée',
    noLots: 'Aucun lot'
  },
  inventurQueue: {
    title: 'Sessions d’inventaire ouvertes',
    hint: 'Brouillons et sessions en attente d’approbation (plusieurs utilisateurs).',
    refresh: 'Actualiser',
    empty: 'Aucune session ouverte',
    noBusiness: 'Entreprise non sélectionnée',
    colId: 'ID',
    colStatus: 'Statut',
    colAdj: 'Écarts',
    colWhen: 'Date',
    colActions: 'Actions',
    open: 'Ouvrir',
    loaded: 'Session d’inventaire chargée',
    status_draft: 'Brouillon',
    status_pending_approval: 'En attente d’approbation',
    status_posted: 'Comptabilisé',
    status_cancelled: 'Annulé'
  },
  inventurPage: {
    title: 'Inventaire',
    subtitle: 'Comptage physique, files d’approbation et mise à jour du stock (ajustements).',
    store: 'Magasin'
  },
  generalLotsTitle: 'Gestion Générale des Lots',
  generalLotsHint: 'Sélectionnez un produit dans le tableau pour gérer ses lots, ou utilisez les boutons d\'action dans le tableau',
  stockLabel: 'Stock',
  noProductsInStock: 'Aucun produit en stock. Les produits doivent être achetés d\'abord pour apparaître dans le stock.',
  noSearchMatch: 'Aucun produit ne correspond à vos critères de recherche.',
  stockAlertsTitle: 'Alertes intelligentes',
  historyLoading: 'Chargement des données...',
  currentStockSummary: 'Résumé du Stock Actuel',
  currentStock: 'Stock actuel',
  totalIn: 'Total entré',
  totalOut: 'Total sorti',
  lotViewDetails: 'Voir détails',
  lotEdit: 'Modifier lot',
  lotDelete: 'Supprimer lot',
  lotDetailsTitle: 'Détails du lot',
  lotEditTitle: 'Modifier le lot',
  lotConfirmDeleteTitle: 'Supprimer le lot ?',
  lotConfirmDeleteMessage: 'Cette action supprime définitivement le lot du stock.',
  lotConfirmDelete: 'Supprimer',
  cancel: 'Annuler',
  close: 'Fermer',
  save: 'Enregistrer',
  lotId: 'ID lot',
  batchNumber: 'N° lot',
  lotLocation: 'Emplacement',
  lotSaveFailed: 'Échec de la sauvegarde du lot',
  lotStatus: 'Statut',
  lotRemainingQty: 'Quantité restante',
  lotTotalQty: 'Quantité totale',
  lotPurchasePrice: 'Prix achat unit.',
  lotSellingPrice: 'Prix vente unit.',
  lotPurchaseValue: 'Valeur achat',
  lotSellingValue: 'Valeur vente',
  lotProfit: 'Profit potentiel',
  lotExpiry: 'Expiration',
  lotSupplier: 'Fournisseur',
  lotCreated: 'Créé le',
  lotUpdated: 'Modifié le',
  lotStatusActive: 'Actif',
  lotStatusExpired: 'Expiré',
  lotStatusSoldOut: 'Épuisé',
  openLotManager: 'Ouvrir gestion lots',
  transferStock: 'Transfert de stock',
  transferStepLocations: 'Sélectionner emplacements',
  transferStepProducts: 'Sélectionner produits',
  transferStepConfirm: 'Confirmer transfert',
  transferSelectLocations: 'Sélectionnez les emplacements pour le transfert',
  transferAddLocation: 'Ajouter nouvel emplacement',
  transferFromLocation: 'De l\'emplacement',
  transferToLocation: 'Vers l\'emplacement',
  transferSelectSource: 'Sélectionnez l\'emplacement source',
  transferSelectTarget: 'Sélectionnez l\'emplacement cible',
  transferSelectProducts: 'Sélectionnez les produits à transférer',
  transferSearchProducts: 'Rechercher des produits...',
  transferProductsSummary: '{{count}} produit(s) • {{qty}} unité(s)',
  transferAvailableStock: 'Stock disponible',
  transferLotsAvailable: 'Lots disponibles ({{count}})',
  transferLotN: 'Lot {{n}}',
  transferExpiry: 'Exp.',
  transferQtyLabel: 'Quantité à transférer',
  transferUnit: 'unité',
  transferUnits: 'unités',
  transferNoProducts: 'Aucun produit disponible à cet emplacement',
  transferConfirmTitle: 'Confirmer le transfert',
  transferSummaryFrom: 'De',
  transferSummaryTo: 'Vers',
  transferSummaryProducts: 'Produits',
  transferSummaryTotalQty: 'Quantité totale',
  transferSelectedProducts: 'Produits sélectionnés',
  transferPrev: 'Précédent',
  transferNext: 'Suivant',
  transferConfirm: 'Confirmer transfert',
  transferInProgress: 'Transfert en cours...',
  transferSuccess: 'Transfert réussi',
  transferError: 'Erreur lors du transfert',
  transferSelectProductsError: 'Veuillez sélectionner les produits et quantités',
  sortFefo: 'FEFO (Premier expiré)',
  sortFifo: 'FIFO (Premier entré)',
  sortLifo: 'LIFO (Dernier entré)',
  sortProfit: 'Plus grand profit',
  sortQuantity: 'Plus grande quantité',
  sortValue: 'Plus grande valeur',
  locationLabel: 'Emplacement:',
  allLocations: 'Tous les emplacements',
  sortLabel: 'Trier:',
  consolidate: 'Consolider',
  searchLotsPlaceholder: 'Rechercher dans les lots...',
  statusFilterLabel: 'Statut:',
  filterAll: 'Tous',
  filterActive: 'Actif',
  filterExpiredStatus: 'Expiré',
  filterSoldOut: 'Épuisé',
  totalStockLabel: 'Stock Total',
  totalValueLabel: 'Valeur Totale',
  potentialProfitLabel: 'Profit Potentiel',
  mergeOpportunities: 'Opportunités de Fusion',
  mergeOpportunitiesTitle: 'Opportunités de Consolidation',
  lotCountUnit: 'lot(s)',
  unitsLabel: 'unités',
  totalValueColon: 'Valeur totale:',
  mergeBtn: 'Consolider',
  lotRemainingQtyCol: 'Quantité Restante',
  lotPurchasePriceCol: 'Prix Achat',
  lotSellingPriceCol: 'Prix Vente',
  lotValueCol: 'Valeur',
  lotProfitCol: 'Profit',
  lotExpirationCol: 'Expiration',
  noLotsFound: 'Aucun lot trouvé',
  noExpiration: 'Sans expiration',
  stockReportTitle: 'Rapport du Stock',
  statusLow: 'Faible',
  statusGood: 'Bon',
  exportTotalProducts: 'Total Produits',
  exportTotalValue: 'Valeur Totale',
  exportLowStockProducts: 'Produits à Stock Faible',
  errDeleteProduct: 'Erreur lors de la suppression du produit',
  successDeleteProduct: 'Produit supprimé avec succès',
  errNoSelection: 'Aucun produit sélectionné pour la suppression',
  errSaveDelete: 'Échec de l\'enregistrement de la suppression',
  confirmBulkDeleteMessage: 'Êtes-vous sûr de vouloir supprimer {{count}} produit(s) ? Cette action est irréversible.',
  errUpdateProduct: 'Erreur lors de la mise à jour du produit',
  successUpdateProduct: 'Produit mis à jour avec succès',
  successBulkDelete: '{{count}} produits supprimés avec succès',
  transferStockBtn: 'Transfert Stock',
  transferFromStore: 'Magasin source',
  transferToStore: 'Magasin destination',
  storeFilterLabel: 'Magasin',
  allStores: 'Tous les magasins',
  skuLabel: 'SKU',
  stockManagementTitle: 'Gestion du Stock',
  currentLocationLabel: 'Emplacement actuel',
  alertsLabel: 'Alertes',
  locationManagement: 'Gestion des Emplacements',
  stockListTitle: 'Liste du Stock',
  confirmDeleteTitle: 'Confirmer la suppression',
  deleteBtn: 'Supprimer',
  locationInline: 'Emplacement',
  errLocationNameRequired: 'Veuillez entrer un nom d\'emplacement',
  errLocationExists: 'Cet emplacement existe déjà',
  errLocationSave: 'Erreur lors de la sauvegarde de l\'emplacement',
  successLocationAdded: 'Emplacement ajouté avec succès',
  errLocationSaveFailed: 'Échec de la sauvegarde de l\'emplacement',
  errNewLocationNameRequired: 'Veuillez entrer un nouveau nom d\'emplacement',
  successLocationUpdated: 'Emplacement mis à jour avec succès',
  errCannotDeletePrincipal: 'Impossible de supprimer l\'emplacement principal',
  successLocationDeleted: 'Emplacement supprimé avec succès',
  locationPrincipal: 'Emplacement principal',
  locationAdditional: 'Emplacement supplémentaire',
  viewStats: 'Voir Statistiques',
  editLocationBtn: 'Modifier Emplacement',
  deleteLocationBtn: 'Supprimer Emplacement',
  addLocation: 'Ajouter Emplacement',
  addLocationTitle: 'Ajouter un Nouvel Emplacement',
  addLocationHint: 'Ajoutez un nouvel emplacement pour stocker vos produits. Vous pouvez ajouter une description optionnelle.',
  locationNameLabel: 'Nom de l\'emplacement',
  locationNamePlaceholder: 'Entrez le nom de l\'emplacement',
  descriptionOptional: 'Description (optionnel)',
  descriptionPlaceholder: 'Entrez la description de l\'emplacement',
  addBtn: 'Ajouter',
  editLocationTitle: 'Modifier l\'Emplacement',
  editLocationHint: 'Modifiez le nom de l\'emplacement. Tous les produits associés à cet emplacement seront mis à jour.',
  newLocationNamePlaceholder: 'Entrez le nouveau nom de l\'emplacement',
  confirmDeleteLocationMessage: 'Êtes-vous sûr de vouloir supprimer l\'emplacement "{{name}}" ? Cette action ne peut pas être annulée.',
  productCountOne: '{{count}} produit',
  productCountMany: '{{count}} produits',
  productsLabel: 'Produits',
  availableLabel: 'Disponible',
  lowLabel: 'Faible',
  totalProductsLabel: 'Total Produits',
  inLocation: 'dans {{location}}',
  inAllLocations: 'dans tous les emplacements',
  availableProductsLabel: 'Produits Disponibles',
  percentOfTotal: 'du total',
  outOfStockAlert: 'Produits en rupture de stock',
  highValueAlert: 'Produits de haute valeur',
  locationDistribution: 'Répartition par Emplacement',
  searchLabel: 'Recherche',
  searchProductsPlaceholder: 'Rechercher des produits...',
  categoryLabel: 'Catégorie',
  allCategories: 'Toutes les Catégories',
  subcategoryLabel: 'Sous-catégorie',
  allSubcategories: 'Toutes les Sous-catégories',
  typeLabel: 'Type',
  allTypes: 'Tous les Types',
  stockStatusLabel: 'Statut du Stock',
  inStockFilter: 'En Stock',
  lowStockFilter: 'Stock Faible',
  outOfStockFilter: 'Rupture de Stock',
  showZeroStock: 'Afficher stock vide',
  smartNoAlerts: 'Aucune alerte ou recommandation',
  smartRecommendations: 'Recommandations Intelligentes',
  orderTodayBtn: "Commander aujourd'hui",
  orderTodayTitle: "À commander aujourd'hui",
  orderTodayEmpty: 'Rien à commander pour le moment',
  orderTodayEmptyHint:
    'Les suggestions utilisent vos ventes récentes et le stock Principal (couverture selon conservation).',
  orderTodaySummary: '{{count}} produit(s) à réapprovisionner · {{selected}} sélectionné(s)',
  orderTodayHint:
    'Cochez les produits, ajustez les quantités, puis créez les commandes directement (sans formulaire).',
  orderTodaySelectAll: 'Tout sélectionner',
  orderTodayDeselectAll: 'Tout désélectionner',
  orderTodayOrderGroup: 'Créer la commande',
  orderTodayCreateAll: 'Créer les commandes',
  orderTodayCreating: 'Création…',
  orderTodayCreateSuccess: '{{orders}} commande(s) créée(s) · {{lines}} ligne(s)',
  orderTodayCreateFailed: 'Impossible de créer les commandes',
  orderTodayNeedSupplier: 'Choisissez un fournisseur pour chaque groupe',
  orderTodayPickSupplier: 'Choisir un fournisseur…',
  orderTodayQtyLabel: 'Qté',
  orderTodayStock: 'Stock {{stock}}',
  orderTodayCoverage: '{{days}} j. de couverture',
  orderTodayQty: 'Commander {{qty}}',
  orderTodayMultiSupplierHint:
    'Plusieurs fournisseurs : une commande séparée sera créée pour chaque groupe.',
  alertLowStockMessage: 'Stock faible: {{name}} ({{current}}/{{threshold}})',
  alertLowStockAction: 'Réapprovisionnement requis',
  alertHighValueMessage: 'Valeur élevée: {{name}} ({{value}})',
  alertHighValueAction: 'Surveillance étroite requise',
  alertExpiringMessage: 'Expire bientôt (FEFO): {{name}} — {{qty}} u. dans {{days}} j. ({{location}})',
  alertExpiringAction: 'Vendre / rotation FEFO en priorité',
  alertHighProfitMessage: 'Marge élevée: {{name}} ({{margin}}%)',
  alertHighProfitAction: 'Mettre en avant à la vente',
  alertSlowMovingMessage: 'Rotation lente: {{name}} (stock {{stock}}, ~{{days}} j. de couverture)',
  alertSlowMovingAction: 'Promo, transfert ou réduction d\'achat',
  loadingLotSystem: 'Chargement du système de lots…',
  unknownSupplier: 'Fournisseur inconnu'
};

export const stockPageAr = {
  viewDetails: 'عرض التفاصيل',
  editProduct: 'تعديل المنتج',
  manageLots: 'إدارة اللوتات',
  deleteProduct: 'حذف المنتج',
  moreActions: 'المزيد من الإجراءات',
  productCol: 'المنتج',
  imageCol: 'صورة',
  categoryCol: 'الفئة',
  subcategoryCol: 'الفئة الفرعية',
  typeCol: 'النوع',
  locationCol: 'الموقع',
  stockCol: 'المخزون',
  inCol: 'دخول',
  outCol: 'خروج',
  lotsCol: 'اللوتات',
  valueCol: 'القيمة',
  actionsCol: 'الإجراءات',
  lowStock: 'مخزون منخفض',
  noLots: 'لا توجد لوتات',
  basedOnPurchases: 'بناءً على المشتريات',
  lotsActive: 'نشط',
  loading: 'جاري التحميل...',
  loadError: 'خطأ في تحميل البيانات',
  noStockData: 'لا توجد بيانات مخزون',
  addProductsHint: 'ابدأ بإضافة منتجات جديدة',
  migrationNeededHint:
    'توجد مشتريات بدون لوتات — المخزون فارغ. قم بترحيل اللوتات.',
  migrationBtn: 'ترحيل اللوتات',
  selectedCount: 'محدد',
  deleteSelected: 'حذف المحدد',
  editProductTitle: 'تعديل المنتج',
  stockHistoryTitle: 'سجل المخزون',
  lotsTitle: 'إدارة اللوتات',
  tabLots: 'اللوتات',
  tabHistory: 'سجل الحركات',
  tabInventur: 'الجرد',
  ledgerHistory: {
    title: 'حركات المخزون',
    standaloneTitle: 'سجل الحركات (كل المنتجات)',
    openBtn: 'سجل الحركات',
    refresh: 'تحديث',
    loading: 'جاري التحميل…',
    showing: '{{shown}} / {{total}} حركة',
    empty: 'لا توجد حركات لهذا الفلتر',
    noBusiness: 'لم يتم اختيار المؤسسة',
    filterProduct: 'المنتج (المعرّف)',
    filterProductPh: 'معرف المنتج…',
    filterType: 'النوع',
    filterAllTypes: 'كل الأنواع',
    filterLocation: 'الموقع',
    filterStore: 'المتجر',
    filterStorePh: 'مثال: الرئيسي…',
    filterLimit: 'الحد',
    colSeq: 'تسلسل',
    colType: 'النوع',
    colQty: 'الكمية',
    colProduct: 'المنتج',
    colLot: 'اللوت',
    colLocation: 'الموقع',
    colStore: 'المتجر',
    colActor: 'المشغّل',
    colWhen: 'التاريخ',
    colNote: 'ملاحظة',
    type_PURCHASE: 'شراء',
    type_SALE: 'بيع',
    type_SALE_RETURN: 'مرتجع بيع',
    type_VOID: 'إلغاء',
    type_TRANSFER_OUT: 'تحويل صادر',
    type_TRANSFER_IN: 'تحويل وارد',
    type_EXPIRY: 'انتهاء صلاحية',
    type_ADJUSTMENT: 'تعديل',
    type_CONSUMPTION: 'استهلاك',
    type_PRODUCTION_CONSUME: 'إنتاج — استهلاك',
    type_PRODUCTION_OUTPUT: 'إنتاج — إخراج'
  },
  inventur: {
    title: 'الجرد الفعلي',
    hint: 'أدخل الكمية الفعلية (وحدة الأساس). تُسجَّل الفروقات كتعديلات مخزون.',
    colLot: 'اللوت',
    colSystem: 'النظام',
    colCounted: 'المعدود',
    colDelta: 'الفرق',
    changes: '{{count}} فرق(فروقات) للتسجيل',
    review: 'مراجعة الفروقات',
    reviewTitle: 'اعتماد الجرد',
    reviewHint: 'راجع الفروقات ثم اعتمدها لتحديث المخزون.',
    approve: 'اعتماد وترحيل',
    saveDraft: 'حفظ مسودة',
    draftSaved: 'تم حفظ مسودة الجرد (بانتظار الاعتماد)',
    backToCount: 'رجوع للعد',
    commit: 'اعتماد الجرد',
    saving: 'جاري الحفظ…',
    success: 'تم تسجيل {{count}} تعديل(ات)',
    noop: 'لا فرق — لا شيء للحفظ',
    failed: 'فشل الجرد',
    noBusiness: 'لم يتم اختيار المؤسسة',
    noLots: 'لا توجد لوتات'
  },
  inventurQueue: {
    title: 'جلسات الجرد المفتوحة',
    hint: 'مسودات وجلسات بانتظار الاعتماد (عدة مستخدمين).',
    refresh: 'تحديث',
    empty: 'لا توجد جلسات مفتوحة',
    noBusiness: 'لم يتم اختيار المؤسسة',
    colId: 'المعرّف',
    colStatus: 'الحالة',
    colAdj: 'فروقات',
    colWhen: 'التاريخ',
    colActions: 'إجراءات',
    open: 'فتح',
    loaded: 'تم تحميل جلسة الجرد',
    status_draft: 'مسودة',
    status_pending_approval: 'بانتظار الاعتماد',
    status_posted: 'مُرحَّل',
    status_cancelled: 'ملغى'
  },
  inventurPage: {
    title: 'الجرد',
    subtitle: 'العد الفعلي وملفات الاعتماد وتحديث المخزون (التعديلات).',
    store: 'المتجر'
  },
  generalLotsTitle: 'إدارة اللوتات العامة',
  generalLotsHint: 'اختر منتجاً من الجدول لإدارة اللوتات الخاصة به، أو استخدم أزرار الإجراءات في الجدول',
  stockLabel: 'المخزون',
  noProductsInStock: 'لا توجد منتجات في المخزون. يجب شراء المنتجات أولاً لظهورها في المخزون.',
  noSearchMatch: 'لا يوجد منتج يتطابق مع معايير البحث الخاصة بك.',
  stockAlertsTitle: 'التنبيهات الذكية',
  historyLoading: 'جاري تحميل البيانات...',
  currentStockSummary: 'ملخص المخزون الحالي',
  currentStock: 'المخزون الحالي',
  totalIn: 'إجمالي الداخل',
  totalOut: 'إجمالي الخارج',
  lotViewDetails: 'عرض التفاصيل',
  lotEdit: 'تعديل اللوتات',
  lotDelete: 'حذف اللوتات',
  lotDetailsTitle: 'تفاصيل اللوتات',
  lotEditTitle: 'تعديل اللوتات',
  lotConfirmDeleteTitle: 'حذف اللوتات؟',
  lotConfirmDeleteMessage: 'ستُحذف اللوتات نهائياً من المخزون.',
  lotConfirmDelete: 'حذف',
  cancel: 'إلغاء',
  close: 'إغلاق',
  save: 'حفظ',
  lotId: 'معرف اللوتات',
  batchNumber: 'رقم اللوط',
  lotLocation: 'الموقع',
  lotSaveFailed: 'فشل حفظ الدفعة',
  lotStatus: 'الحالة',
  lotRemainingQty: 'الكمية المتبقية',
  lotTotalQty: 'الكمية الإجمالية',
  lotPurchasePrice: 'سعر الشراء',
  lotSellingPrice: 'سعر البيع',
  lotPurchaseValue: 'قيمة الشراء',
  lotSellingValue: 'قيمة البيع',
  lotProfit: 'الربح المحتمل',
  lotExpiry: 'تاريخ الانتهاء',
  lotSupplier: 'المورد',
  lotCreated: 'تاريخ الإنشاء',
  lotUpdated: 'آخر تعديل',
  lotStatusActive: 'نشط',
  lotStatusExpired: 'منتهي',
  lotStatusSoldOut: 'نفذ',
  openLotManager: 'فتح إدارة اللوتات',
  transferStock: 'نقل المخزون',
  transferStepLocations: 'اختيار المواقع',
  transferStepProducts: 'اختيار المنتجات',
  transferStepConfirm: 'تأكيد النقل',
  transferSelectLocations: 'اختر المواقع للنقل',
  transferAddLocation: 'إضافة موقع جديد',
  transferFromLocation: 'من الموقع',
  transferToLocation: 'إلى الموقع',
  transferSelectSource: 'اختر الموقع المصدر',
  transferSelectTarget: 'اختر الموقع الهدف',
  transferSelectProducts: 'اختر المنتجات للنقل',
  transferSearchProducts: 'البحث عن المنتجات...',
  transferProductsSummary: '{{count}} منتج • {{qty}} وحدة',
  transferAvailableStock: 'المخزون المتاح',
  transferLotsAvailable: 'اللوتات المتاحة ({{count}})',
  transferLotN: 'اللوتات {{n}}',
  transferExpiry: 'انتهاء',
  transferQtyLabel: 'الكمية للنقل',
  transferUnit: 'وحدة',
  transferUnits: 'وحدات',
  transferNoProducts: 'لا توجد منتجات متاحة في هذا الموقع',
  transferConfirmTitle: 'تأكيد النقل',
  transferSummaryFrom: 'من',
  transferSummaryTo: 'إلى',
  transferSummaryProducts: 'المنتجات',
  transferSummaryTotalQty: 'الكمية الإجمالية',
  transferSelectedProducts: 'المنتجات المحددة',
  transferPrev: 'السابق',
  transferNext: 'التالي',
  transferConfirm: 'تأكيد النقل',
  transferInProgress: 'جاري النقل...',
  transferSuccess: 'تم النقل بنجاح',
  transferError: 'حدث خطأ أثناء النقل',
  transferSelectProductsError: 'يرجى تحديد المنتجات والكميات',
  sortFefo: 'أول منتهي الصلاحية',
  sortFifo: 'أول وارد أول صادر',
  sortLifo: 'آخر وارد أول صادر',
  sortProfit: 'أعلى ربح',
  sortQuantity: 'أكبر كمية',
  sortValue: 'أعلى قيمة',
  locationLabel: 'الموقع:',
  allLocations: 'جميع المواقع',
  sortLabel: 'ترتيب:',
  consolidate: 'دمج الدفعات',
  searchLotsPlaceholder: 'البحث في اللوتات...',
  statusFilterLabel: 'الحالة:',
  filterAll: 'الكل',
  filterActive: 'نشط',
  filterExpiredStatus: 'منتهي الصلاحية',
  filterSoldOut: 'منتهي',
  totalStockLabel: 'إجمالي المخزون',
  totalValueLabel: 'القيمة الإجمالية',
  potentialProfitLabel: 'الربح المحتمل',
  mergeOpportunities: 'فرص الدمج',
  mergeOpportunitiesTitle: 'فرص دمج الدفعات',
  lotCountUnit: 'دفعة',
  unitsLabel: 'وحدة',
  totalValueColon: 'إجمالي القيمة:',
  mergeBtn: 'دمج',
  lotRemainingQtyCol: 'الكمية المتبقية',
  lotPurchasePriceCol: 'سعر الشراء',
  lotSellingPriceCol: 'سعر البيع',
  lotValueCol: 'القيمة',
  lotProfitCol: 'الربح',
  lotExpirationCol: 'انتهاء الصلاحية',
  noLotsFound: 'لا توجد دفعات',
  noExpiration: 'بدون انتهاء',
  stockReportTitle: 'تقرير المخزون',
  statusLow: 'منخفض',
  statusGood: 'جيد',
  exportTotalProducts: 'إجمالي المنتجات',
  exportTotalValue: 'إجمالي القيمة',
  exportLowStockProducts: 'منتجات منخفضة المخزون',
  errDeleteProduct: 'خطأ في حذف المنتج',
  successDeleteProduct: 'تم حذف المنتج بنجاح',
  errNoSelection: 'لم يتم اختيار أي منتج للحذف',
  errSaveDelete: 'فشل حفظ الحذف',
  confirmBulkDeleteMessage: 'هل أنت متأكد من حذف {{count}} منتج؟ لا يمكن التراجع عن هذا الإجراء.',
  errUpdateProduct: 'خطأ في تحديث المنتج',
  successUpdateProduct: 'تم تحديث المنتج بنجاح',
  successBulkDelete: 'تم حذف {{count}} منتج بنجاح',
  transferStockBtn: 'نقل المخزون',
  transferFromStore: 'المتجر المصدر',
  transferToStore: 'المتجر الوجهة',
  storeFilterLabel: 'المتجر',
  allStores: 'كل المتاجر',
  skuLabel: 'SKU',
  stockManagementTitle: 'إدارة المخزون',
  currentLocationLabel: 'الموقع الحالي',
  alertsLabel: 'التنبيهات',
  locationManagement: 'إدارة المواقع',
  stockListTitle: 'قائمة المخزون',
  confirmDeleteTitle: 'تأكيد الحذف',
  deleteBtn: 'حذف',
  locationInline: 'الموقع',
  errLocationNameRequired: 'يرجى إدخال اسم الموقع',
  errLocationExists: 'هذا الموقع موجود بالفعل',
  errLocationSave: 'خطأ في حفظ الموقع',
  successLocationAdded: 'تم إضافة الموقع بنجاح',
  errLocationSaveFailed: 'فشل في حفظ الموقع',
  errNewLocationNameRequired: 'يرجى إدخال اسم الموقع الجديد',
  successLocationUpdated: 'تم تحديث الموقع بنجاح',
  errCannotDeletePrincipal: 'لا يمكن حذف الموقع الرئيسي',
  successLocationDeleted: 'تم حذف الموقع بنجاح',
  locationPrincipal: 'الموقع الرئيسي',
  locationAdditional: 'موقع إضافي',
  viewStats: 'عرض الإحصائيات',
  editLocationBtn: 'تعديل الموقع',
  deleteLocationBtn: 'حذف الموقع',
  addLocation: 'إضافة موقع',
  addLocationTitle: 'إضافة موقع جديد',
  addLocationHint: 'أضف موقعًا جديدًا لتخزين المنتجات. يمكنك إضافة وصف اختياري للموقع.',
  locationNameLabel: 'اسم الموقع',
  locationNamePlaceholder: 'أدخل اسم الموقع',
  descriptionOptional: 'الوصف (اختياري)',
  descriptionPlaceholder: 'أدخل وصف الموقع',
  addBtn: 'إضافة',
  editLocationTitle: 'تعديل الموقع',
  editLocationHint: 'قم بتعديل اسم الموقع. سيتم تحديث جميع المنتجات المرتبطة بهذا الموقع.',
  newLocationNamePlaceholder: 'أدخل اسم الموقع الجديد',
  confirmDeleteLocationMessage: 'هل أنت متأكد من حذف الموقع "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
  productCountOne: '{{count}} منتج',
  productCountMany: '{{count}} منتج',
  productsLabel: 'المنتجات',
  availableLabel: 'متوفر',
  lowLabel: 'منخفض',
  totalProductsLabel: 'إجمالي المنتجات',
  inLocation: 'في {{location}}',
  inAllLocations: 'في جميع المواقع',
  availableProductsLabel: 'المنتجات المتوفرة',
  percentOfTotal: 'من الإجمالي',
  outOfStockAlert: 'منتجات نفدت من المخزون',
  highValueAlert: 'منتجات عالية القيمة',
  locationDistribution: 'توزيع المواقع',
  searchLabel: 'البحث',
  searchProductsPlaceholder: 'البحث عن المنتجات...',
  categoryLabel: 'الفئة',
  allCategories: 'جميع الفئات',
  subcategoryLabel: 'الفئة الفرعية',
  allSubcategories: 'جميع الفئات الفرعية',
  typeLabel: 'النوع',
  allTypes: 'جميع الأنواع',
  stockStatusLabel: 'حالة المخزون',
  inStockFilter: 'في المخزون',
  lowStockFilter: 'مخزون منخفض',
  outOfStockFilter: 'نفذ المخزون',
  showZeroStock: 'إظهار المخزون الفارغ',
  smartNoAlerts: 'لا توجد تنبيهات أو توصيات',
  smartRecommendations: 'التوصيات الذكية',
  orderTodayBtn: 'اطلب اليوم',
  orderTodayTitle: 'ما يجب طلبه اليوم',
  orderTodayEmpty: 'لا يوجد ما يُطلب حالياً',
  orderTodayEmptyHint:
    'تعتمد الاقتراحات على مبيعاتك الأخيرة ومخزون الرئيسي (التغطية حسب مدة الحفظ).',
  orderTodaySummary: '{{count}} منتج(ات) لإعادة التموين · {{selected}} محدد',
  orderTodayHint:
    'حدّد المنتجات، عدّل الكميات، ثم أنشئ الطلبيات مباشرة (بدون نموذج).',
  orderTodaySelectAll: 'تحديد الكل',
  orderTodayDeselectAll: 'إلغاء التحديد',
  orderTodayOrderGroup: 'إنشاء الطلبية',
  orderTodayCreateAll: 'إنشاء الطلبيات',
  orderTodayCreating: 'جاري الإنشاء…',
  orderTodayCreateSuccess: 'تم إنشاء {{orders}} طلبية · {{lines}} سطر',
  orderTodayCreateFailed: 'تعذر إنشاء الطلبيات',
  orderTodayNeedSupplier: 'اختر مورداً لكل مجموعة',
  orderTodayPickSupplier: 'اختر مورداً…',
  orderTodayQtyLabel: 'الكمية',
  orderTodayStock: 'المخزون {{stock}}',
  orderTodayCoverage: '{{days}} يوم تغطية',
  orderTodayQty: 'اطلب {{qty}}',
  orderTodayMultiSupplierHint:
    'عدة موردين: تُنشأ طلبية منفصلة لكل مجموعة.',
  alertLowStockMessage: 'مخزون منخفض: {{name}} ({{current}}/{{threshold}})',
  alertLowStockAction: 'إعادة الطلب مطلوبة',
  alertHighValueMessage: 'قيمة عالية: {{name}} ({{value}})',
  alertHighValueAction: 'مراقبة دقيقة مطلوبة',
  alertExpiringMessage: 'قرب انتهاء الصلاحية (FEFO): {{name}} — {{qty}} وحدة خلال {{days}} يوم ({{location}})',
  alertExpiringAction: 'البيع / التدوير FEFO أولاً',
  alertHighProfitMessage: 'هامش مرتفع: {{name}} ({{margin}}%)',
  alertHighProfitAction: 'إبراز المنتج في البيع',
  alertSlowMovingMessage: 'حركة بطيئة: {{name}} (مخزون {{stock}}، تغطية ~{{days}} يوم)',
  alertSlowMovingAction: 'عرض ترويجي أو نقل أو تقليل الشراء',
  loadingLotSystem: 'جاري تحميل نظام الدُفعات…',
  unknownSupplier: 'مورد غير معروف'
};
